import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import { Input, } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import Modal from 'react-responsive-modal'
import CustomSelect from '../../../components/CustomSelect'
import { createDocumentJournal, updateDocumentJournal } from '../../../actions/documents_journal'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import { getPersonnelList } from '../../../actions/personnel/personnel'
import { getStudents } from '../../../actions/students/list'


const validationSchema = Yup.object({
  post: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
})

const arrHow = [{ name: 'Преподаватель', value: 'Преподаватель' }, { name: 'Учащийся', value: 'Учащийся' }]

export default function ModalComponent({ data, closeModal, params, typeOfDocumentslist }) {

  const dispatch = useDispatch()

  const { personnelList } = useSelector((state) => state.personnel)
  const { studentList } = useSelector(state => state.students.list) || {}

  const [image, setImage] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true)

  const addMode = !data?.xp_key

  const handleCreate = async (values) => {
    dispatch(createDocumentJournal(values, params))
    closeModal()
  }

  const handleUpdate = async ({ id, ...values }) => {
    dispatch(updateDocumentJournal(id, values, image))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    // validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  // 19.03.2026 - Преобразование "Учителя" в "Преподаватель", "Учащиеся" в "Учащийся" для дропдауна
  useEffect(() => {
    if (data?.owner === 'Учителя') {
      setFieldValue('owner', 'Преподаватель')
    } else if (data?.owner === 'Учащиеся') {
      setFieldValue('owner', 'Учащийся')
    }
  }, [])

  // 19.03.2026 - При изменении владельца отправляем запрос на получение списка
  useEffect(() => {
    if (values.owner === 'Преподаватель' || values.owner === 'Учителя') {
      dispatch(getPersonnelList('Работает'))
    } else if (values.owner === 'Учащийся' || values.owner === 'Учащиеся') {
      dispatch(getStudents({ status: 'all' }))
    }
    if (!initialLoad) {
      setFieldValue('mid', null)
    } else {
      setInitialLoad(false)
    }
  }, [values.owner])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  // const handlePick = () => {
  //   document.getElementById('filePicker').click()
  // }
  // const handleChangeFile = (e) => {
  //   setImage(Object.values(e.target.files)[0])
  // }

  // const fetchPhoto = async (id) => {
  //   const { data } = await api.get(`/cook_team/images/${id}`, { responseType: 'blob' })
  //   setImage(data)
  // }

  // useEffect(() => {
  //   if (data && !addMode) {
  //     fetchPhoto(values.id)
  //   }
  // }, [data])

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} style={{ display: "flex", justifyContent: 'space-evenly', flexDirection: 'column' }}>


            <div className={styles.inputsRow}>
              <CustomSelect
                title='Владелец'
                valuesName="owner"
                className={styles.selectModal}
                options={arrHow}
                width='120px'
                value={values.owner}
                setFieldValue={setFieldValue}
                withoutAll
              />
            </div>

            <div className={styles.inputsRow}>
              <CustomSelect
                key={`fio-${values.owner}-${personnelList?.length || 0}-${studentList?.length || 0}`}
                title='ФИО'
                valuesName="mid"
                className={styles.selectModal}
                options={
                  (values.owner === 'Преподаватель' || values.owner === 'Учителя')
                    ? personnelList && arrayForSelect(personnelList, 'fio', 'mid')
                    : (values.owner === 'Учащийся' || values.owner === 'Учащиеся')
                      ? studentList && arrayForSelect(studentList, 'fio', 'mid')
                      : []
                }
                width='120px'
                value={values.mid}
                setFieldValue={setFieldValue}
                withoutAll
              />
            </div>

            <div className={styles.inputsRow}>
              <CustomSelect
                title='Вид документа'
                valuesName="name"
                className={styles.selectModal}
                options={typeOfDocumentslist && arrayForSelect(typeOfDocumentslist, 'name', 'name')}
                width='120px'
                value={values.name}
                setFieldValue={setFieldValue}
                withoutAll
                error={error('name')}
              />
            </div>
            <div className={styles.inputsRow}>
              <span className={styles.label}>Дата выдачи:</span>
              <Input type='date' value={values.ddate} onChange={(e) => setFieldValue('ddate', e.target.value)} />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Серия'
                name='dseries'
                value={values.dseries}
                error={error('dseries')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Номер'
                name='dnum'
                value={values.dnum}
                error={error('dnum')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Примечание'
                name='dtext'
                value={values.dtext}
                error={error('dtext')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />

            </div>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal >
  )
}
